import SettingsAdminService from '../services/SettingsAdminService'

const SaveErrorFront = (error: any, errortext:string|null, payload:string|null) => {
   try {
        // Monta log completo do erro
        const errorLog: any = {
            message: error?.message ?? null,
            stack: error?.stack ?? null,
            name: error?.name ?? null,
            response: {
                status: error?.response?.status ?? null,
                statusText: error?.response?.statusText ?? null,
                data: error?.response?.data ?? null,
                headers: error?.response?.headers ?? null,
                config: error?.response?.config ?? null,
            },
            request: error?.request ?? null,
            timestamp: new Date().toISOString(),
            requestPayload: (payload)?JSON.stringify(payload, null, 2):null
        };

        // Envia para seu logger (transformando em JSON legível)
        const requestlog:any = {
            ErrorMessage:errortext,
            Payload:JSON.stringify(errorLog, null, 2),
            UserId:null
        };
        SettingsAdminService.postSetErrorFrontEnd(requestlog);
    } catch (logErr) {
        // Em último caso, se até o log falhar, não trava o app
        console.error("Erro ao salvar log:", logErr);
    }
}

function getBrowserName() {
    const ua = navigator.userAgent;

    if (/chrome|crios|crmo/i.test(ua) && !/edge|edgios|opr\//i.test(ua)) return "Chrome";
    if (/firefox|fxios/i.test(ua)) return "Firefox";
    if (/safari/i.test(ua) && !/chrome|crios|crmo/i.test(ua)) return "Safari";
    if (/edg/i.test(ua)) return "Edge";
    if (/opr\//i.test(ua)) return "Opera";

    return "Navegador Desconhecido";
}

const HelperSystem = {
    SaveErrorFront,
    getBrowserName
}

export default HelperSystem;